import React, { useEffect, useRef, useState } from "react";
import data from "../../json/landingpage/publishingsolution.json";
import { ReactComponent as Icon } from "../../Icons/whitearrow.svg";
import parse from "html-react-parser";

const Publishingsolution = () => {
  const [currentItem, setCurrentItem] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);
  const ref = useRef();

  useEffect(() => {
    if (ref.current) {
      ref.current.src =
        process.env.PUBLIC_URL + data.products[currentItem].videourl;
      ref.current.load();
      setIsPlaying(false);
    }
  }, [currentItem]);

  const handlePlay = () => {
    if (ref.current) {
      ref.current.play();
      setIsPlaying(true);
    }
  };
  const handleNext = (item) => {
    if (item < data.products.length - 1) {
      setCurrentItem((prev) => prev + 1);
    }
  };
  const handlePrev = (item) => {
    if (item > 0) {
      setCurrentItem((prev) => prev - 1);
    }
  };

  return (
    <div className=" w-screen py-20  bg-[#090A20] relative publishing">
      <div className="2xl:container m-auto flex flex-col gap-8 md:gap-12 px-6 md:px-10 lg:px-20 ">
        <div className="flex flex-col gap-3 w-full text-center items-center">
          <h2 className="text-orangeyellow lg:text-20 md:text-18 text-16 font-semibold  text-center">  {data.Title}</h2>
          <h3 className="text-primarycolor font-semibold text-20 min-[450px]:text-24 md:text-36 lg:text-48 text-center  w-full sm:w-[90%] lg:w-[80%] text-white">{data.Heading}</h3>
        </div>
        <div className="flex flex-col gap-12 items-left lg:flex-row lg:items-center">
          <div className="mt-5 lg:mt-0 w-full lg:w-3/5 relative overflow-hidden">
            {!isPlaying && (
              <>
                <button
                  onClick={handlePlay}
                  className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 rounded-[24px] z-20"
                >
                  <span className="text-white text-2xl w-16 h-16 sm:h-24 sm:w-24 rounded-full flex justify-center items-center bg-popup backdrop-blur-sm">
                    <img
                      className="w-[80%]"
                      src={
                        process.env.PUBLIC_URL +
                        "/images/Herosection/play icon.svg"
                      }
                      alt="Play"
                    />
                  </span>
                </button>
              </>
            )}
            <div className="w-full rounded-[24px] overflow-hidden">
              {!isPlaying && (
                <img
                  src={
                    process.env.PUBLIC_URL +
                    `${data.products[currentItem].poster}`
                  }
                  alt="Video Poster"
                  className="w-full block object-cover border-[2px] border-journeyborder rounded-[24px]"
                />
              )}
              <video
                controls
                ref={ref}
                className={` ${isPlaying ? "block" : "hidden"} w-full rounded-[32px] min-h-[400px] object-cover`}
                poster={
                  process.env.PUBLIC_URL +
                  `${data.products[currentItem].poster}`
                }
              >
                <source
                  // src={process.env.PUBLIC_URL + data.products[2].videourl}
                  type="video/mp4"
                ></source>
              </video>
            </div>
          </div>
          <div className="w-full lg:w-2/5">
            <div className="flex flex-row justify-center lg:flex-col gap-2 lg:gap-4">
              {/* {data.products.map((el, i) => ( */}
              <div className="flex lg:gap-6 relative">
                <div
                  className={`w-full text-left text-14 lg:text-18 font-medium text-primarycolor flex flex-col gap-2 sm:gap-4`}
                >
                  <h3 className="text-20 lg:text-24 font-bold text-white max-sm:mb-3">{parse(data.products[currentItem].title)}</h3>
                  <p className="text-14 lg:text-16 text-[#EDF1FF]">{data.products[currentItem].para}</p>
                  <div className="flex gap-3 text-white mt-6 sm:mt-6">
                    <button
                      onClick={() => handlePrev(currentItem)}
                      className=" flex h-[45px] w-[45px]  rounded-full border-[1px] border-highlight hover:bg-ctaorange publish-hover flex justify-center items-center"
                      aria-label="Go to previous video"
                    >
                      <Icon className="text-highlight arrowicon rotate-180" />
                    </button>
                    <button
                      onClick={() => handleNext(currentItem)}
                      className="flex h-[45px] w-[45px] rounded-full border-[1px] border-highlight hover:bg-ctaorange publish-hover flex justify-center items-center"
                      aria-label="Go to next video"
                    >
                      <Icon className="text-highlight arrowicon" />
                    </button>
                  </div>
                </div>
              </div>
              {/* ))} */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Publishingsolution;
